import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Row, Col, Button, Input, Label, ModalHeader, ModalFooter, ModalBody, Form, FormGroup, FormFeedback } from 'reactstrap'
import { validateItem } from '../_validate'
import { Field, reduxForm, change, formValueSelector } from 'redux-form'
import PropTypes from 'prop-types'

import { selectHelper, formatHelper, normalizeHelper } from '../../../../../common/helpers'

class FormItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            activeItem: {
                price: null
            },
        }
        this.onSubmitQuotationItem = this.onSubmitQuotationItem.bind(this);
        this.renderInputField = this.renderInputField.bind(this);
        this.renderItemsField = this.renderItemsField.bind(this);
        this.renderStaticField = this.renderStaticField.bind(this);
        this.renderRadioDiscountField = this.renderRadioDiscountField.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.state.activeItem != null) {
            this.checkItemChange(prevProps)
            this.checkQuantityChange(prevProps)
            this.checkTypeUnitDiscountChamge(prevProps)
            this.checkDiscountChange(prevProps)
            let price = this.props.itemType != 'Ofertas' ? this.state.activeItem.price : this.state.activeItem.total_price
            this.props.changeValueForm('QuotationItemForm', 'before_price', price)
        }
    }
    checkItemChange(prevProps) {
        if (this.props.itemId != prevProps.itemId) {
            if (this.props.itemType == 'Productos') {
                this.setState({
                    activeItem: selectHelper.getFromDataByLabel('id', this.props.itemId, this.props.products)
                })
            }
            else if (this.props.itemType == 'Servicios') {
                this.setState({
                    activeItem: selectHelper.getFromDataByLabel('id', this.props.itemId, this.props.services)
                })
            } else if (this.props.itemType == 'Ofertas') {
                this.setState({
                    activeItem: selectHelper.getFromDataByLabel('id', this.props.itemId, this.props.offers)
                })
            }
        }
    }

    checkQuantityChange(prevProps) {
        const { itemQuantity, itemTypeDiscount, itemUnitDiscount, itemType } = this.props;
        if (prevProps.itemQuantity != this.props.itemQuantity && this.props.itemQuantity != null) {

            const beforePrice = itemType != 'Ofertas' ? this.state.activeItem.price : this.state.activeItem.total_price;
            if (itemUnitDiscount && itemTypeDiscount) {
                let newPrice = itemTypeDiscount == 'true' ? beforePrice * itemQuantity * (1 - (itemUnitDiscount / 100)) : (beforePrice * itemQuantity - itemUnitDiscount);
                this.props.changeValueForm('QuotationItemForm', 'price', formatHelper.toTwoDecimal(newPrice))
                return;
            }
            let newPrice = beforePrice * itemQuantity;
            this.props.changeValueForm('QuotationItemForm', 'price', formatHelper.toTwoDecimal(newPrice))
        }
    }
    checkTypeUnitDiscountChamge(prevProps) {
        if (prevProps.itemTypeDiscount != this.props.itemTypeDiscount && this.props.itemTypeDiscount != null) {
            this.props.changeValueForm('QuotationItemForm', 'unit_discount', null)
        }
    }
    checkDiscountChange(prevProps) {

        const { itemQuantity, itemTypeDiscount, itemUnitDiscount, itemType } = this.props;
        const beforePrice = itemType != 'Ofertas' ? this.state.activeItem.price : this.state.activeItem.total_price;
        if (itemTypeDiscount == undefined || !beforePrice || !itemQuantity) return
        if (prevProps.itemUnitDiscount != itemUnitDiscount) {
            if (!itemUnitDiscount) {
                let newPrice = itemTypeDiscount ? beforePrice * itemQuantity : beforePrice * itemQuantity;
                this.props.changeValueForm('QuotationItemForm', 'price', formatHelper.toTwoDecimal(newPrice))
                return;
            }
            let newPrice = itemTypeDiscount == 'true' ? beforePrice * itemQuantity * (1 - (itemUnitDiscount / 100)) : (beforePrice * itemQuantity - itemUnitDiscount);
            this.props.changeValueForm('QuotationItemForm', 'price', formatHelper.toTwoDecimal(newPrice))
        }
    }
    toggleModal(itemType) {
        this.props.toggleModal(itemType)
    }
    onSubmitQuotationItem(values) {
        if (this.props.itemType == 'Ofertas') values.total_price = values.price;
        this.props.onSubmitQuotationItem(values, this.state.activeItem);
    }

    renderProductsItems() {
        return this.props.products.map(product => {
            return (
                <option key={product.id} value={product.id}>{product.name}</option>
            )
        })
    }
    renderServicesItems() {
        return this.props.services.map(service => {
            return (
                <option key={service.id} value={service.id}>{service.name}</option>
            )
        })
    }
    renderOffersItems() {
        return this.props.offers.map(offer => {
            return (
                <option key={offer.id} value={offer.id}>{offer.name}</option>
            )
        })
    }
    renderInputField(field) {
        const { meta: { touched, error } } = field;
        const hasError = touched && error ? true : false
        const labelClass = field.labelClass ? field.labelClass : 'mt-1'

        return (
            <FormGroup row >
                <Col md='2'>
                    <Label className={labelClass}>{field.label}</Label>
                </Col>
                <Col>
                    <Input {...field.input} invalid={hasError} type={field.type} ></Input>
                    {hasError == true ?
                        <FormFeedback>{error}</FormFeedback>
                        : null}
                </Col>
            </FormGroup>
        )
    }

    renderStaticField(field) {
        const { meta: { touched, error } } = field;
        const hasError = touched && error ? true : false
        const labelClass = field.labelClass ? field.labelClass : 'mt-1'

        return (
            <FormGroup row >
                <Col md='2' >
                    <Label className={labelClass}>{field.label}</Label>
                </Col>
                <Col>
                    <Input {...field.input} invalid={hasError} type={field.type} readOnly />
                </Col>
            </FormGroup>
        )
    }
    renderRadioDiscountField(field) {
        const { meta: { touched, error }, input } = field;
        const hasError = touched && error ? true : false
        const labelClass = field.labelClass ? field.labelClass : 'mt-1'
        return (
            <FormGroup row >
                <Col md='2' >
                    <Label className={labelClass}>{field.label}</Label>
                </Col>
                <Col md='5'>
                    <Label className='ml-4' >
                        <Input
                            {...field.input}
                            type="radio"
                            name={field.input.name}
                            value={true}

                        />
                        Porcentaje
                    </Label>
                </Col>
                <Col md='5'>
                    <Label>
                        <Input
                            {...field.input}
                            type="radio"
                            name={field.input.name}
                            value={false}
                        />
                        Dinero
                    </Label>
                </Col>
            </FormGroup>
        )
    }
    renderTypeItems(type) {
        if (type == 'Productos') {
            return this.renderProductsItems()
        } else if (type == 'Servicios') {
            return this.renderServicesItems()
        } else if (type == 'Ofertas') {
            return this.renderOffersItems()
        }
    }

    renderItemsField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false

        return (
            <FormGroup row>
                <Col md='2' >
                    <Label htmlFor="select">{this.props.itemType}:</Label>
                </Col>
                <Col >
                    <Input {...field.input} type="select" invalid={hasError} >
                        <option key={0} value={0}>Seleccione...</option>
                        {
                            this.renderTypeItems(this.props.itemType)
                        }
                    </Input>
                    {hasError == true ?
                        <FormFeedback>{error}</FormFeedback>
                        : null}
                </Col>
            </FormGroup>
        )
    }

    render() {
        const { handleSubmit } = this.props
        return (
            <Form onSubmit={handleSubmit(handleSubmit(this.onSubmitQuotationItem))}>
                <ModalHeader>Añadir Item</ModalHeader>
                <ModalBody>
                    <Field name='id' component={this.renderItemsField} />
                    <Field name='before_price' label='Precio Unitario(S/):' type='number' component={this.renderStaticField} />
                    <Field name='quantity' label='Cantidad:' component={this.renderInputField} normalize={normalizeHelper.integerOnlyField(1)} />
                    <Field name='type_unit_discount' label='Tipo Descuento:' component={this.renderRadioDiscountField} />
                    <Field name='unit_discount' label='Descuento:' type='number' component={this.renderInputField} normalize={(this.props.itemTypeDiscount && this.props.itemType && this.props.itemQuantity ? (this.props.itemTypeDiscount == 'true' ? normalizeHelper.decimalOnlyField(0,100) : normalizeHelper.decimalOnlyField(0, this.props.itemType != 'Ofertas' ? this.state.activeItem.price * this.props.itemQuantity : this.state.activeItem.total_price * this.props.itemQuantity)) : normalizeHelper.decimalOnlyField())} />
                    <Field name='price' label='Total (S/):' component={this.renderStaticField} />
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col className='mt-3'>
                            <Button type='submit' color='primary' className='mr-2' ><i className="fa fa-save mr-1" /> Guardar</Button>
                            <Button color='secondary' onClick={() => this.toggleModal()} ><i className="fa fa-chevron-left mr-1" /> Cancelar</Button>
                        </Col>
                    </Row>
                </ModalFooter>

            </Form>
        )
    }
}

FormItem.propTypes = {

    products: PropTypes.array,
    services: PropTypes.array,
    offers: PropTypes.array,

    itemType: PropTypes.string,
    onSubmitQuotationItem: PropTypes.func,
    toggleModal: PropTypes.func,

}

const formSelector = formValueSelector('QuotationItemForm')

function mapStateToProps(state) {
    return {
        itemPrice: formSelector(state, 'price'),
        itemId: formSelector(state, 'id'),
        itemQuantity: formSelector(state, 'quantity'),
        itemTypeDiscount: formSelector(state, 'type_unit_discount'),
        itemUnitDiscount: formSelector(state, 'unit_discount'),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeValueForm: change
    }, dispatch)
}

export default reduxForm({
    form: 'QuotationItemForm',
    touchOnBlur: false,
    enableReinitialize: true,
    validate: validateItem
})(connect(mapStateToProps, mapDispatchToProps)(FormItem))


// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationEdit/Forms/FormItem.js